// Client-side pills filter for status-tagged lists (test results, topics).
// Items carry data-status; a tab shows items whose status matches its filter
// param, and the "all" tab shows everything. An item rendered in several
// layouts (mobile cards + desktop table) registers each copy as a target, so
// all copies stay in sync.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["item", "tab", "empty"]
    static values = { current: String }
    static classes = ["activeTab", "inactiveTab"]

    connect() {
        this.apply()
    }

    filter(event) {
        this.currentValue = event.params.filter
        this.apply()
    }

    apply() {
        let visible = 0
        this.itemTargets.forEach(item => {
            const show = this.currentValue === "all" || item.dataset.status === this.currentValue
            // The hidden ATTRIBUTE, not the .hidden class: preflight's
            // [hidden] rule carries !important, so it also wins over component
            // classes that set display (e.g. .unified-list-row--dense's flex).
            item.hidden = !show
            if (show) visible += 1
        })

        this.tabTargets.forEach(tab => {
            const active = tab.dataset.statusFilterFilterParam === this.currentValue
            tab.classList.remove(...(active ? this.inactiveTabClasses : this.activeTabClasses))
            tab.classList.add(...(active ? this.activeTabClasses : this.inactiveTabClasses))
            // Tabs marked up as a WAI-ARIA tablist (the landing category tabs)
            // also get their selected state announced.
            if (tab.getAttribute("role") === "tab") tab.setAttribute("aria-selected", String(active))
        })

        this.emptyTargets.forEach(target => {
            target.hidden = visible > 0
        })
    }
}
